import classNames from 'classnames'
import React from 'react'
import {useTranslation} from '@wix/yoshi-flow-editor'
import s from '../../fields.scss'
import {LabelProps} from './index'

export const Label: React.FC<LabelProps> = ({classes, dataHook, required, htmlFor, caption, tabIndex = -1}) => {
  const {t} = useTranslation()

  return (
    <div
      className={classNames(s.caption, classes)}
      data-hook={dataHook}
      tabIndex={tabIndex}
      aria-label={`${required ? t('requiredInput') : ''} ${caption}`}
    >
      {required && <span aria-hidden="true">*</span>}
      <label htmlFor={htmlFor} aria-hidden="true">
        {caption}
      </label>
    </div>
  )
}
